// extracted by mini-css-extract-plugin
module.exports = {"message":"Q22JW","nostrip":"A+Hys","red":"GQyeY","green":"hf2-D","yellow":"FBkyQ"};